import { CHAT_ASSIGNMENT_CRITERIA_ACTION_TYPE } from '../actions';

const initialState = {};

const chatAssignmentCriteriaSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CHAT_ASSIGNMENT_CRITERIA_ACTION_TYPE.GET_CHAT_ASSIGNMENT_CRITERIA_SCHEMA:
      return payload || state;

    default:
      return state;
  }
};

export default chatAssignmentCriteriaSchemaReducer;
